{
  "availableBalance": "Số dư khả dụng",
  "lockedQuantity": "Số lượng bị khóa",
  "deposit": "Nhận token",
  "assetDetails": "Chi tiết tài sản",
  "filter": {
    "all": "Tất cả",
    "deposit": "Nhận token",
    "swap": "Quy đổi",
    "payment": "Thanh toán",
    "buyCoin": "Mua token",
    "sellCoin": "Bán token",
    "return": "Phần thưởng",
    "others": "Khác"
  }
}
